import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/* Old client links and bookmarks pointed the five-step wizard here. The deck replaced it. */
const LegacyCompanySetupRedirect: React.FC = () => {
  const [params] = useSearchParams();
  const referral = params.get('ref');
  if (referral) return <Navigate to={`/signup?ref=${encodeURIComponent(referral)}`} replace />;
  return <Navigate to="/signup" replace />;
};

export default LegacyCompanySetupRedirect;
